/**
 * 
 * Handles the behavior of the events list
 */
let GridArticles = {
	/**
	 * Entry point
	 */
	_init: () => {
		document.addEventListener('DOMContentLoaded', GridArticles._ready);
	},
	/**
	 * Fires when document ready
	 */
	_ready: () => {
		// rebind pagination link listeners
		GridArticles._addPaginationLinkListeners();
		
		document.addEventListener('navigationpill:click', GridArticles._navFilterClickHandler);
		document.addEventListener('navigationsubpill:click', GridArticles._navFilterClickHandler);
	},
	_addPaginationLinkListeners: () => {
		const paginationWrapper = document.querySelector('.gridarticles-wrapper-pagination');
		
		// do they exist?
		if (paginationWrapper) {
			paginationWrapper.addEventListener('click', (e) => {
				const paginationLink = e.target.closest('.gridarticles-wrapper-pagination a');
				
				if (paginationLink) {
					e.preventDefault();
					GridArticles._paginationLinkClickHandler(paginationLink);
				}
			});
		}
	},
	/**
	 * Fired when clicking a navigation pill
	 */
	_navFilterClickHandler: async () => {
		// refresh the grid articles via the api
		try {
			let currentURL = new URL(window.location);
			let fetchURL = new URL(ajaxurl);
			const body = document.querySelector('body');
			let postId = Array.from(body.classList).find(className => className.startsWith('page-id'));
			postId = postId.split('-')[2];
			
			currentURL.searchParams.forEach((value, key) => {
				fetchURL.searchParams.append(key, value);
			});
			
			// build the form data to send to the BE
			let formData = new FormData();
			formData.append('action', 'refresh_grid_articles');
			formData.append('post_id', postId);
			
			// use async/await to fetch the data
			const res = await fetch(fetchURL, {
				method: 'POST',
				body: formData
			});
			const articlesList = await res.text();
			
			// render the response
			document.querySelector('.gridarticles').outerHTML = articlesList;
			
			// rebind pagination link listeners
			GridArticles._addPaginationLinkListeners();
			
			document.dispatchEvent(new Event('list:updated'));
		} catch (error) {
			console.error(error);
		}
	},
	/**
	 * Fired when clicking a pagination link
	 * @param {object} link the event object
	 */
	_paginationLinkClickHandler: (link) => {
		// update the URL & history
		const url = new URL(window.location);
		url.searchParams.set('page_num', parseInt(link.textContent.trim()));

		history.pushState({}, "", url);
		
		// scroll to the top of the post list
		const gridArticles = document.querySelector('.navpills');
		const rootStyles = getComputedStyle(document.documentElement);
		const headerBarHeight = parseFloat(rootStyles.getPropertyValue('--header-height-expanded').trim());
		
		gridArticles.scrollIntoView({
			behavior: 'smooth',
			offsetTop: headerBarHeight
		});
		
		// rebuild list
		GridArticles._navFilterClickHandler();
	},
};

// beginning.
GridArticles._init();
